var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-padding no-margin"},[(_vm.path == '/member/services')?_c('MemberServices'):_vm._e(),(_vm.path == '/member/services/add-services')?_c('AddService'):_vm._e(),(_vm.path == '/member/services/service')?_c('ServiceDetail'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }